import React from 'react'

export type UsePopperReturnType = {
  id: string
  toggle: React.MouseEventHandler<HTMLButtonElement>
  setAnchorEl: (el: HTMLButtonElement | null) => void
  popperProps: {
    open: boolean
    anchorEl: null | HTMLButtonElement
    id: string | undefined
  }
}

export const usePopper = (id: string): UsePopperReturnType => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLButtonElement>(null)
  const open = Boolean(anchorEl)

  const toggle = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const popperProps = {
    open,
    anchorEl,
    id: open ? id : undefined,
  }

  return {
    id,
    toggle,
    popperProps,
    setAnchorEl,
  }
}
